import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { usePartner } from '../PartnerContext';

const cardSx = {
  width: '100%',
  borderRadius: 2,
  boxShadow: 1,
  transition: 'box-shadow 0.2s, transform 0.2s',
  '&:hover': {
    boxShadow: 4,
    transform: 'translateY(-2px) scale(1.01)',
  },
  p: 2.5,
  minWidth: 0,
};
const cardContentSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  p: 0,
};
const valueRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mt: 0.5,
};

const SettingsView = ({ DUMMY_DATA }) => {
  const { org, project } = usePartner();
  const cardData = DUMMY_DATA?.[org]?.projects?.[project]?.settings || [];
  const [copiedIdx, setCopiedIdx] = useState(null);

  const handleCopy = (value, idx) => {
    navigator.clipboard.writeText(value);
    setCopiedIdx(idx);
    setTimeout(() => setCopiedIdx(null), 1200);
  };

  return (
    <div style={{ margin: 0, padding: '40px 2vw', boxSizing: 'border-box' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: 20,
        }}
        className="settings-cards-grid"
      >
        {cardData.map((item, idx) => (
          <Card key={item.label} elevation={1} sx={cardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, letterSpacing: 0.2, mb: 0.5 }}>
                {item.label}
              </Typography>
              <div style={valueRowSx}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: '1.08rem', wordBreak: 'break-all', flex: 1, color: '#222' }}>
                  {item.value}
                </Typography>
                <Tooltip title={copiedIdx === idx ? 'Copied!' : 'Copy'} placement="top">
                  <IconButton onClick={() => handleCopy(item.value, idx)} size="small" sx={{ ml: 1 }}>
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <style>{`
        @media (min-width: 700px) {
          .settings-cards-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default SettingsView; 